import {
  UserPlusIcon_default
} from "./chunk-7SBRNCOU.mjs";
export {
  UserPlusIcon_default as default
};
